<app-global-loading></app-global-loading>

<k-header [logo]="logo" [navItems]="navItems" [title]="title">

  <!-- <k-header-middle-section>
      <k-dropdown [options]="clientList" [(ngModel)]="selectedClient" (change)="clientSelected($event)"></k-dropdown>
    </k-header-middle-section> -->

  <k-header-right-section (mouseleave)="leaveButton($event)" (mouseover)="showButton($event)" > 
    <!-- <k-notifications style="display: inline-block;"></k-notifications>   -->
    <!-- <span *ngIf="isLoggedIn">
      {{ userName }}
    </span> -->
    <button class="round-button background-transparent user-avatar user-avatar-btn user_avatar_info"
      style="display: inline-block; top: -3px" #anchor >
      
      <k-icon [icon]=" { type: 'image', src: './../assets/avatar-placeholder.jpg', extraClass: 'user-avatar'}"></k-icon>
      <label class="user_details">
        <span class="user_name">{{userName}}</span>
        <k-icon [icon]=" { type: 'fas', name:'caret-down', extraClass: 'user-downArrow'}"></k-icon>
      </label>
    </button>
    <kendo-popup id="pop-user-options" #popup [anchor]="{ nativeElement: anchor }"
      (anchorViewportLeave)="showUserOptions = false" *ngIf="showUserOptions">
      <div class="dropdown-item" (click)="changePassword()">
        <div class="row">
          <div class="col-2 text-center dropdown-item-col">
            <k-icon [icon]="{type: 'fas', name: 'key'}"></k-icon>
          </div>
          <div class="col-10 dropdown-item-col">
            Change Password
          </div>
        </div>
      </div>
      <div class="dropdown-item">
        <div class="row">
          <div class="col-2 text-center dropdown-item-col">
            <k-icon [icon]="{type: 'fas', name: 'sign-out-alt'}"></k-icon>
          </div>
          <span class="col-10 dropdown-item-col" (click)="logout()">
            Sign Off 
          </span>
        </div>
      </div>
    </kendo-popup>
  </k-header-right-section>
</k-header>

<!-- <div class="container-fluid">
  <div class="common_page_space">
    <router-outlet></router-outlet>
  </div>
</div> -->
<div class="common_page_space">
  <router-outlet></router-outlet>
</div>
<app-timeout></app-timeout>
<app-password-update></app-password-update>


<!-- <k-idle-manager [idleTimeLimit]="300" [modalTimeLimit]="60"></k-idle-manager> -->
<k-modal [id]="'renewTokenFailed'" [overlay]="true">
  <k-modal-header [dismiss]="false" [backgroundColor]="'brand-main'">
    Login Session Ended
  </k-modal-header>
  <k-modal-body>
    <p>Please login again to re-initiate the session</p>
    <k-button  [label]="'Login'" [color]="'brand-main'" [type]="KButtonType.KCGButton" (buttonClick)="redirectToLogin()"
    [icon]="{type: 'fas', name: 'user'}" >
  </k-button>
  </k-modal-body>
</k-modal>
<k-footer></k-footer>
